import {
  DerivedUnderwritingProfileStatus,
  Duration,
  IdDocumentType,
  JobRiskClass,
  ProposalStatus,
  ReplaceInsurance,
  RiderType,
} from '@emma-labs/shared/typescript';

export const frenchTranslation = new Map([
  ['Oui', 'Oui'],
  ['Non', 'Non'],
  ['Ventes', 'Ventes'],
  ['Profil', 'Profil'],
  ['Documentation', 'Documentation'],
  ['Compte bancaire', 'Compte bancaire'],
  ['Carte de crédit', 'Carte de crédit'],
  ['NONE', 'Aucun'],
  [RiderType.CHILD, 'Enfant'],
  [RiderType.CANCER, 'Cancer'],
  [RiderType.CRITICAL_ILLNESS, 'Maladie grave'],
  [RiderType.DISABILITY, 'Invalidité'],
  [RiderType.ACCIDENTAL_DEATH, 'Décès accidentel'],
  [RiderType.GUARANTEED_INSURABILITY, 'Assurabilité garantie'],
  [RiderType.WAIVER_OF_PREMIUM, 'Exonération de prime'],
  ['CHILD_ENDORSEMENT_15K', '15 000 $ de couverture'],
  ['CHILD_ENDORSEMENT_25K', '25 000 $ de couverture'],
  ['driverLicense', 'Permis de conduire'],
  ['healthInsurance', "Carte d'assurance maladie"],
  ['passport', 'Passeport'],
  ['PROPOSAL_IN_PROGRESS_BTN', 'Poursuivre demande'],
  ['PROPOSAL_SENT_BTN', 'Modifier demande'],
  ['SALE_COMPLETED_BTN', 'Voir la proposition'],
  ['SEND_PROPOSAL', 'Envoyer la demande au client'],
  ['RESEND_PROPOSAL', 'Envoyer un rappel au client'],
  ['Soumission rapide', 'Soumission rapide'],
  ['Recherche client', 'Recherche client'],
  ['Rapports de vente', 'Rapports de vente'],
  ['Espace tarification', 'Espace tarification'],
  ['Emma Élite', 'Emma Élite'],
  ['Emma Supérieur', 'Emma Supérieur'],
  ['Emma Standard', 'Emma Standard'],
  ['Comparateur de soumission', 'Comparateur de soumission'],
  [
    'Impossible de copier le client, vous devez le faire manuellement',
    'Impossible de copier le client, vous devez le faire manuellement',
  ],
  [
    'Le client a été copié dans la plateforme de courtage avec succès',
    'Le client a été copié dans la plateforme de courtage avec succès',
  ],
  [
    'Une erreur est survenue durant la copie du client vers la plateforme de courtage',
    'Une erreur est survenue durant la copie du client vers la plateforme de courtage',
  ],
  [`Voir plus d'options`, `Voir plus d'options`],
  [`Voir moins d'options`, `Voir moins d'options`],
  [DerivedUnderwritingProfileStatus.APPROVED, 'Approuvé'],
  [DerivedUnderwritingProfileStatus.REFUSED, 'Refusé'],
  [DerivedUnderwritingProfileStatus.PENDING_UNDERWRITER_ACTION, 'En attente du tarificateur'],
  [DerivedUnderwritingProfileStatus.PENDING_CLIENT_ACTION, 'En attente du client'],
  [DerivedUnderwritingProfileStatus.PENDING_EXTERNAL_ACTION, `En attente d'un partenaire externe`],
  [DerivedUnderwritingProfileStatus.CANCELED, 'Sans suivi'],
  [IdDocumentType.DRIVER_LICENSE, 'Permis de conduire'],
  [IdDocumentType.HEALTH_INSURANCE, `Carte d'assurance maladie`],
  [IdDocumentType.PASSPORT, 'Passeport'],
  [ProposalStatus.ONGOING, 'En cours'],
  [ProposalStatus.PENDING_CHECKOUT, 'Signature'],
  [ProposalStatus.PENDING_UNDERWRITING, 'Tarification'],
  [ProposalStatus.PENDING_EXTRA_QUESTIONNAIRES, 'Questionnaires supplémentaires'],
  [ProposalStatus.PENDING_EXTERNAL_ACTION, `En attente d'un partenaire externe`],
  [ProposalStatus.PENDING_MODIFICATION_DECISION, 'Décision'],
  [ProposalStatus.APPROVED, 'Approuvée'],
  [ProposalStatus.REFUSED, 'Refusée'],
  [ProposalStatus.ABANDONED, 'Abandonée'],
  [ReplaceInsurance.YES, 'Remplacer'],
  [ReplaceInsurance.NO, 'Conserver'],
  [ReplaceInsurance.UNKNOWN, 'Je ne sais pas'],
  [JobRiskClass.INELIGIBLE, 'Inéligible'],
  [Duration.P100, "Payable jusqu'à 100 ans"],
  [Duration.P65, "Payable jusqu'à 65 ans"],
  [Duration.V20, 'Payable en 20 ans'],
]);
